var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 12.333a1 1 0 0 1 1-1h14.391l-6.22-5.59a1 1 0 0 1 1.337-1.487l8.16 7.334a1 1 0 0 1 .017 1.472l-8.16 7.667a1 1 0 1 1-1.37-1.458l6.32-5.938H3a1 1 0 0 1-1-1Z"
  })));
};
export default SvgArrowRight;